import React from 'react';
import LandingPageCategoriesComponent from '../../../components/landing-page-categories';

const LandingPageCategories = () => (
  <LandingPageCategoriesComponent/>
);

export default LandingPageCategories;
